import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en_translation from './locales/en.json';
import zh_translation from './locales/zh.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    ns: ['translation'],
    defaultNS: 'translation',
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly',
    resources: {
      en: en_translation,
      zh: zh_translation
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  }, (err, t) => {
    if (err) {
      console.error('i18n Initialization Error:', err);
    } else {
      console.log('i18n initialized successfully');
    }
  });

export default i18n;
